<template>
  <v-container
    id="caregivers"
    fluid
    tag="section"
  >
    <v-row>
      <edit-caregiver-dialog
        v-if="aProfile"
        :a-profile="aProfile"
        :c-profile="cProfile"
        :u-profile="uProfile"
        @close="editDialogClosed"
      />
    </v-row>
    <v-row>
      <v-col
        cols="12"
      >
        <v-card>
          <v-card-text>
            <v-row>
              <v-col
                cols="3"
              >
                <base-app-text-field
                  v-model="nameToSearch"
                  label="Search"
                  append-icon="mdi-arrow-right-circle"
                  prev-icon="null"
                  next-icon="null"
                  @keyup.enter="searchByName"
                  @click:append="searchByName"
                />
              </v-col>
              <v-col
                cols="12"
                class="text-center"
              >
                <v-pagination
                  v-if="!!pages"
                  v-model="pageNum"
                  :length="pages"
                  :disabled="!(pages)"
                  @input="loadData"
                />
              </v-col>
            </v-row>
            <v-data-table
              :headers="headers"
              :items="caregivers"
              :search="search"
              disable-pagination
              hide-default-footer
              class="cursor-pointer"
              item-key="uuid"
              @click:row="editCG"
            >
              <template v-slot:item.agencyName="{ item }">
                <span>{{ agencyNameByExternalId(item.agencyExternalId) }}</span>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'
  // import CaregiverEditView from './component/caregiver/CaregiverEditView.vue'
  import CGEditDialog from './component/caregiver/CGEditDialog.vue'

  import { eventBus, busEvents } from '@/EventBus'

  export default {
    name: 'CaregiversView',
    components: {
      // CaregiverEditView,
      'edit-caregiver-dialog': CGEditDialog,
    },
    data () {
      return {
        search: '',
        headers: [
          {
            sortable: true,
            text: 'ID',
            value: 'id',
          },
          {
            sortable: true,
            text: 'firstName',
            value: 'firstName',
          },
          {
            sortable: true,
            text: 'lastName',
            value: 'lastName',
          },
          {
            sortable: true,
            text: 'Email',
            value: 'email',
          },
          {
            sortable: true,
            text: 'AgencyExternalId',
            value: 'agencyExternalId',
          },
          {
            sortable: true,
            text: 'Agency',
            value: 'agencyName',
          },
          {
            sortable: true,
            text: 'Profile source',
            value: 'source',
          },
          {
            sortable: true,
            text: 'StaffStatus',
            value: 'staffStatus',
            align: 'right',
          },
        ],
        dialog: false,
        currentCaregiver: {},
        originalCaregiver: {},
        currentCaregiverId: -1,
        currentCaregiverUUID: null,
        agencyProfile: {},
        nameToSearch: null,
        totalRows: null,
        pageSize: null,
        pageNum: 1,
        aProfile: null,
        cProfile: null,
      }
    },
    computed: {
      ...mapGetters({
        agencyByExternalId: 'agency/AGENCY_BY_EXTERNAL_ID',
        caregivers: 'caregiver/CAREGIVERS',
      }),
      pages () {
        return (this.totalRows && this.pageSize) ? Math.ceil(this.totalRows / this.pageSize) : 0
      },
    },
    mounted () {
      this.setCaregivers([])
    },
    methods: {
      ...mapMutations({
        updateAgencies: 'agency/UPDATE_AGENCIES',
        setLoading: 'app/SET_LOADING',
        setCaregivers: 'caregiver/SET_CAREGIVERS',
      }),
      agencyNameByExternalId (externalId) {
        return this.agencyByExternalId(externalId).name
      },
      searchByName () {
        if (this.nameToSearch) {
          this.loadData()
        }
      },
      editDialogClosed (savedCaregiver) {
        this.aProfile = null
        this.cProfile = null
        if (savedCaregiver) {
          // update item in table
          const index = this.caregivers.indexOf(this.caregivers.find(function (element, index) {
            return element.id === savedCaregiver.id
          }))
          if (index > -1) {
            this.caregivers[index].firstName = savedCaregiver.firstName
            this.caregivers[index].middleName = savedCaregiver.middleName
            this.caregivers[index].lastName = savedCaregiver.lastName
            this.caregivers[index].email = savedCaregiver.email
            this.caregivers[index].staffStatus = savedCaregiver.staffStatus
          }
        }
        this.dialog = false
      },
      loadData () {
        this.setLoading(true)
        this.$careConnect.searchCaregivers(this.nameToSearch, this.pageNum)
          .then(resp => {
            this.setCaregivers(resp.profiles)
            this.totalRows = resp.paging.totalRows
            this.pageSize = resp.paging.pageSize
            this.pageNum = resp.paging.pageNum
          })
          .catch(err => {
            const text = err.json ? err.json.error : 'Failed to search caregivers'
            eventBus.$emit(busEvents.APP_NOTIFICATION, { type: 'error', text })
          })
          .finally(() => {
            this.setLoading(false)
          })
      },
      async editCaregiver (item) {
        // get agency details
        const { id, userUuid, agencyExternalId } = item
        const agency = this.agencyByExternalId(agencyExternalId)
        this.dialog = true
        this.currentCaregiverId = id
        this.currentCaregiverUUID = userUuid
        this.agencyProfile = { id, agencyId: agency.id, agencyExternalId: agency.agencyExternalId }
      },
      editCG (item) {
        this.setLoading(true)
        const { id, agencyExternalId } = item
        const agency = this.agencyByExternalId(agencyExternalId)

        this.$careConnect.getCaregiverAgencyProfile(id, agency.id)
          .then(resp => {
            const { agencyProfile, userProfile } = resp
            const uProfile = JSON.parse(JSON.stringify(userProfile))
            this.cProfile = userProfile ? userProfile.commonProfile : null
            this.aProfile = agencyProfile
            this.uProfile = uProfile
          })
          .catch(err => {
            const text = err.json ? err.json.error : 'Failed to load agency profile'
            eventBus.$emit(busEvents.APP_NOTIFICATION, { type: 'error', text })
          })
          .finally(() => {
            this.setLoading(false)
          })
      },
    },
  }
</script>
<style scoped>
.cursor-pointer tbody tr:hover {
  cursor: pointer;
}
</style>
